module.exports = __webpack_public_path__ + "media/images/landing_page/digweddash4-f80228dcc399ddc11f440bf3eb4bb1c6.webp";